module.exports = __webpack_public_path__ + "static/img/yy4.f9489c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy4.jpg
// module id = 8vqL
// module chunks = 1